import ReactGA from "react-ga4";

type PageViewParams = {
  title: string | null;
  path?: string;
};

export function SendPageView(
  { title, path }: PageViewParams = {
    title: null,
    path: window.location.pathname,
  },
) {
  if (!title) return;
  ReactGA.send({
    hitType: "pageview",
    title,
    page: path,
  });
}
